export const CapabilityFlags = {
  TemperatureVarianceAlert: 'temperatureVarianceAlert',
  FuelVarianceAlert: 'fuelVarianceAlert',
  LiveWelcomeMessage: 'liveWelcomeMessage',
  LiveSpotMessage: 'liveSpotMessage',
  LivePullMessage: 'livePullMessage',
  AllowManualMove: 'allowManualMove',
  AllowImageCapture: 'allowImageCapture',
  AllowDepartDirectFromDoor: 'allowDepartDirectFromDoor',
  AllowLocationEdit: 'allowLocationEdit',
  IsWeightFunctionEnabled: 'isWeightFunctionEnabled',
  AllowProductProtectionInDoors: 'allowProductProtectionInDoors',
  AllowProductProtectionForPartialTrailer: 'allowProductProtectionForPartialTrailer',
  AllowFreightTypes: 'allowFreightTypes',
  ShipmentDate: 'shipmentDate',
  Inspection: 'inspection',
  StorageAttribute: 'storageAttribute',
  IsTemperatureAndFuelAlertEnabled: 'isTemperatureAndFuelAlertEnabled',
  TemperatureVariance: 'temperatureVariance',
  FuelLevel: 'fuelLevel',
  ShipmentNumber: 'shipmentNumber',
  SealNumber: 'sealNumber',
  DirectTask: 'allowDirectTask',
  AllowProductProtection: 'allowProductProtection',
};

export type CapabilityFlags = (typeof CapabilityFlags)[keyof typeof CapabilityFlags];
